export const expensesGet = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'EXPENSES_GET',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const expensesGetSuccess = (items, totalItems) => {
    return {
        type: 'EXPENSES_GET_SUCCESS',
        payload: { items, totalItems }
    }
}

export const expensesGetError = (error) => {
    return {
        type: 'EXPENSES_GET_ERROR',
        payload: error
    }
}

export const expensesSetSearchField = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'EXPENSES_SET_SEARCH_FIELD',
        payload: searchField
    }
}

export const expensesSetSorting = (selectedSortOption, sortDirection) => {
    return {
        type: 'EXPENSES_SET_SORTING',
        payload: { selectedSortOption, sortDirection }
    }
}

export const expensesLoadMore = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'EXPENSES_LOAD_MORE',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const expensesLoadMoreSuccess = (items, totalItems) => {
    return {
        type: 'EXPENSES_LOAD_MORE_SUCCESS',
        payload: { items, totalItems }
    }
}

export const expensesLoadMoreError = (error) => {
    return {
        type: 'EXPENSES_LOAD_MORE_ERROR',
        payload: error
    }
}

export const expensesDeleteItem = (itemId) => {
    return {
        type: 'EXPENSES_DELETE_ITEM',
        payload: itemId
    }
}

export const expensesDeleteItemSuccess = (itemId) => {
    return {
        type: 'EXPENSES_DELETE_ITEM_SUCCESS',
        payload: itemId
    }
}

export const expensesDeleteItemError = (error) => {
    return {
        type: 'EXPENSES_DELETE_ITEM_ERROR',
        payload: error
    }
}

export const expensesSetDeleted = () => {
    return {
        type: 'EXPENSES_SET_DELETED'
    }
}

export const expensesUnsetDeleted = () => {
    return {
        type: 'EXPENSES_UNSET_DELETED'
    }
}

export const expensesSetMessage = (message) => {
    return {
        type: 'EXPENSES_SET_MESSAGE',
        payload: message
    }
}

export const expensesUnsetMessage = () => {
    return {
        type: 'EXPENSES_UNSET_MESSAGE'
    }
}

export const expensesUnsetError = () => {
    return {
        type: 'EXPENSES_UNSET_ERROR'
    }
}

export const expensesGetDetails = (itemId) => {
    return {
        type: 'EXPENSES_GET_DETAILS',
        payload: itemId
    }
}

export const expensesGetDetailsSuccess = (item) => {
    return {
        type: 'EXPENSES_GET_DETAILS_SUCCESS',
        payload: item
    }
}

export const expensesGetDetailsError = (error) => {
    return {
        type: 'EXPENSES_GET_DETAILS_ERROR',
        payload: error
    }
}

export const expensesSetInsertField = (field, value) => {
    return {
        type: 'EXPENSES_SET_INSERT_FIELD',
        payload: { field, value }
    }
}

export const expensesInsert = (item) => {
    return {
        type: 'EXPENSES_INSERT',
        payload: item
    }
}

export const expensesInsertSuccess = (item) => {
    return {
        type: 'EXPENSES_INSERT_SUCCESS',
        payload: item
    }
}

export const expensesInsertError = (error) => {
    return {
        type: 'EXPENSES_INSERT_ERROR',
        payload: error
    }
}

export const expensesUnsetInserted = () => {
    return {
        type: 'EXPENSES_UNSET_INSERTED'
    }
}

export const expensesSetCustomer = (customer) => {
    return {
        type: 'EXPENSES_SET_CUSTOMER',
        payload: customer
    }
}

export const expensesLoadUpdate = (id) => {
    return {
        type: 'EXPENSES_LOAD_UPDATE',
        payload: id
    }
}

export const expensesLoadUpdateSuccess = (item) => {
    return {
        type: 'EXPENSES_LOAD_UPDATE_SUCCESS',
        payload: item
    }
}

export const expensesLoadUpdateError = (error) => {
    return {
        type: 'EXPENSES_LOAD_UPDATE_ERROR',
        payload: error
    }
}

export const expensesSetUpdateField = (field, value) => {
    return {
        type: 'EXPENSES_SET_UPDATE_FIELD',
        payload: { field, value }
    }
}

export const expensesUpdate = (id, item) => {
    return {
        type: 'EXPENSES_UPDATE',
        payload: {id, item}
    }
}

export const expensesUpdateSuccess = (item) => {
    return {
        type: 'EXPENSES_UPDATE_SUCCESS',
        payload: item
    }
}

export const expensesUpdateError = (error) => {
    return {
        type: 'EXPENSES_UPDATE_ERROR',
        payload: error
    }
}

export const expensesUnsetUpdated = () => {
    return {
        type: 'EXPENSES_UNSET_UPDATED'
    }
}


